import React from 'react';
import styled, { css } from 'styled-components';
import { colors, weights } from '~/styles';

const Article = styled.article`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: fit-content;
  background-color: ${({ backgroundColor }) => {
    return backgroundColor ? backgroundColor : 'transparent';
  }};
  padding: ${({ padding }) => {
    return padding ? padding : '1rem';
  }};
`;

function Page(props) {
  return <Article {...props} />;
}

Page.Header = styled.header`
  display: flex;
  align-items: center;
  position: sticky;
  left: 1rem;
  z-index: 7;
  max-width: calc(100cqi - 2rem);
`;

Page.TabHeader = styled.header`
  display: flex;
  align-items: center;
  position: sticky;
  left: 1rem;
  z-index: 6;
  margin-top: 1.5rem;
  max-width: calc(100cqi - 2rem);
`;

Page.Info = styled.div`
  display: flex;
  flex-direction: column;
`;

Page.Eyebrow = styled.h3`
  color: ${colors.grey40};
  font-size: 0.75rem;
  font-weight: ${weights.black};
  letter-spacing: 0.05rem;
  text-transform: uppercase;
  margin-top: 0.1rem;
`;

Page.Title = styled.h1`
  font-size: 1.25rem;
  font-weight: ${weights.light};
`;

Page.Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-left: auto;
  gap: 1rem;
`;

Page.Section = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 1.5rem;

  ${({ sticky }) =>
    sticky &&
    css`
      position: sticky;
      left: 1rem;
      z-index: 4;
      max-width: calc(100cqi - 2rem);
    `}
`;

Page.Filters = styled.div`
  margin-top: 1rem;
  position: sticky;
  left: 1rem;
  z-index: 5;
  max-width: calc(100cqi - 2rem);

  display: flex;
  flex-direction: row;
  gap: 1rem;
  flex-wrap: wrap-reverse;
`;

Page.ListView = styled.div`
  margin-top: 1.5rem;
  margin-left: -1rem;
  margin-right: -1rem;
`;

const TabsContainer = styled.div`
  position: sticky;
  left: 1rem;
  margin-top: 1.6rem;
  max-width: calc(100cqi - 2rem);
`;

const Tabs = styled.div`
  display: flex;
  /* Horizontal only: the tab bar never scrolls vertically, and a stray vertical bar would show up as a grey
     block beside the tabs at whatever width rounds the content a fraction taller than the box. */
  overflow-x: auto;
  overflow-y: hidden;
  min-height: max-content;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  > ul {
    flex: 1;

    li {
      white-space: nowrap;
    }
  }
`;

Page.Tabs = function PageTabs(props) {
  return (
    <TabsContainer>
      <Tabs data-page-tabs {...props} />
    </TabsContainer>
  );
};

Page.Content = styled.div`
  flex: 1;
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
`;

Page.Main = styled.main`
  display: flex;
  flex-direction: column;
  flex: 4;
  flex-basis: 40rem;
  min-width: 0;
`;

Page.Widgets = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
  grid-auto-rows: 1fr;
  gap: 1.5rem;
`;

Page.Description = styled.div`
  margin-top: 0.25rem;
  font-size: 0.875rem;
  margin-right: 1rem;
  color: ${colors.grey55};
`;

export default Page;
